"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BodyTextToSpeechV1TextToSpeechVoiceIdPostApplyTextNormalization = void 0;
exports.BodyTextToSpeechV1TextToSpeechVoiceIdPostApplyTextNormalization = {
    Auto: "auto",
    On: "on",
    Off: "off",
};
